import { useCallback, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthStatusView } from "./AuthStatusView";
import { useAuthSessionOrchestrator } from "./AuthSessionOrchestrator";
import { clearAuthRedirectTarget, getAuthRedirectTarget } from "./authRedirectTarget";

/**
 * Handles the Auth0 callback route outside the normal WorkUI application shell.
 */
export function Auth0CallbackPage() {
  const navigate = useNavigate();
  const redirectTarget = useMemo(() => getAuthRedirectTarget() ?? "/", []);
  const { beginLogin, stage } = useAuthSessionOrchestrator();

  const handleAuthenticated = useCallback(() => {
    clearAuthRedirectTarget();
    navigate(redirectTarget, { replace: true });
  }, [navigate, redirectTarget]);

  useEffect(() => {
    if (stage.status === "authenticated") {
      handleAuthenticated();
    }
  }, [handleAuthenticated, stage.status]);

  if (stage.status === "authenticated") {
    return null;
  }

  if (stage.status === "error") {
    return (
      <AuthStatusView
        message={stage.message}
        onRetry={() => void beginLogin(redirectTarget)}
        reason={stage.reason}
        status="error"
      />
    );
  }

  return <AuthStatusView status="authenticating" />;
}
